<template>
    <ul class="export ml-auto">
        <li class="relative" @click="toggle" v-click-outside="close">
            <span class="ico-export icon largest"></span>

            <ul class="floating-menu bottom centered" v-if="isVisible">
                <li>
                    <a href="mailto:transport@algarexperience.pt">Email</a>
                </li>
                <li @click="printTo('pdf')">
                    Export PDF
                </li>
                <li @click="printTo('xls')">
                    Export XLS
                </li>
            </ul>
        </li>

        <li class="printer">
            <span class="ico-print icon largest"></span>
        </li>
    </ul>
</template>

<script>
    export default {
        props: {
            reservations: Array
        },
        data: function() {
            return {
                isVisible: false
            }
        },
        methods: {
            toggle: function() {
                this.isVisible = !this.isVisible;
            },
            close: function() {
                this.isVisible = false;
            },
            printTo: function(format) {

            }
        }
    }
</script>

<style lang="scss">
    @import '../assets/scss/_variables.scss';

    .export {
        border-radius: 4px;
        background-color: $lightest;
        border: 1px solid $light;

        > li {
            display: inline-block;
            padding: 0.5rem 0.75rem;

            .icon {
                color: $medium;
            }

            &:first-child {
                border-right: 1px solid $light;
            }

            &:hover {
                .icon {
                    color: $dark;
                    cursor: pointer;
                }
            }
        }

        .floating-menu {
            width: 300%;
        }
    }
</style>



// WEBPACK FOOTER //
// Export.vue?18552de6